import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Spinner, Box, List, Flex, Text } from "samba-ui";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import { updateUserApplications, getUserApplications } from "../redux/users";

const availableApps = [
  "real-time-tv-ratings",
  "rt-cid-tv-integrations-webpage"
];

const UserApplications = ({
  userId,
  user,
  getUserApplications,
  updateUserApplications
}) => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const req = async () => {
      setLoading(true);
      await getUserApplications(userId);
      setLoading(false);
    };
    req();
  }, [getUserApplications, userId]);

  const onToggleChange = async (e, currentApps, appName) => {
    e.persist();
    const { checked } = e.target;
    if (checked) {
      currentApps.push(appName);
    } else {
      const index = currentApps.findIndex(a => a === appName);
      if (index > -1) {
        currentApps.splice(index, 1);
      }
    }

    const body = { applications: currentApps };
    setLoading(true);
    await updateUserApplications(userId, body);
    setLoading(false);
  };
  return (
    <Box mt={3}>
      <List.Header borderColor="#d6d6d6 !important">
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize={1} color="secondary">
            User's Applications
          </Text>
        </Flex>
      </List.Header>
      {loading ? (
        <List.Item borderColor="#d6d6d6 !important">
          <Flex justifyContent="center">
            <Spinner variant="medium" />
          </Flex>
        </List.Item>
      ) : (
        availableApps &&
        availableApps.length &&
        availableApps.map(app => (
          <List.Item borderColor="#d6d6d6 !important" key={app}>
            <Flex alignItems="center" justifyContent="space-between">
              <Text fontSize={1} color="palette.ink.normal">
                {app}
              </Text>
              <Box>
                <Toggle
                  checked={user.applications && user.applications.includes(app)}
                  onChange={e => onToggleChange(e, user.applications, app)}
                />
              </Box>
            </Flex>
          </List.Item>
        ))
      )}
    </Box>
  );
};

const mapStateToProps = (state, props) => ({
  user: state.users[props.userId]
});

const mapDispatchToProps = dispatch => ({
  getUserApplications: userId => dispatch(getUserApplications(userId)),
  updateUserApplications: (userId, body) =>
    dispatch(updateUserApplications(userId, body))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserApplications);
